module.exports = __webpack_public_path__ + "static/media/lfCargo.a2ca8e24.png";